export interface dadosLoginI { 
    mail: string;
    password?: string;
    confirm_password?: string;
}

export interface formLoginI { 
    values: dadosLoginI,
    form: any;
}

export const dadosLoginInitialState: dadosLoginI = { 
    mail: '',
    password: '',
    confirm_password: ''
}
